var map = {
	"./29_car.mp3": "ee35",
	"./30_doll.mp3": "058b",
	"./31_ball.mp3": "4cd9",
	"./32_robot.mp3": "cb4c",
	"./M_Brilliant.mp3": "4d13",
	"./M_Excellent.mp3": "87a8",
	"./M_Fantastic.mp3": "826e",
	"./M_Great.mp3": "fb41",
	"./M_Perfect.mp3": "92ee",
	"./M_Think again.mp3": "fceb",
	"./M_Try again.mp3": "1159",
	"./M_Very good.mp3": "d700",
	"./M_Well done.mp3": "6218",
	"./M_Work harder.mp3": "fcd0",
	"./click.mp3": "ded9",
	"./false.mp3": "1fe7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c479";